import {FC, useEffect} from "react";
import {PubSub} from "../utility/PubSub";
import {useNavigate} from "react-router-dom";
import {useRecoilTransaction_UNSTABLE} from "recoil";
import {AccessContextData, DefaultAccessContextData} from "./access/AppContextProvider";
import {LoginContext} from "../pages/LoginContext";

export const LogoutProvider: FC<any> = ({children}) => {
   const navigate = useNavigate();

   const logout = useRecoilTransaction_UNSTABLE(({set}) => () => {
      set(AccessContextData, DefaultAccessContextData)
      set(LoginContext, {
         accessToken: '',
         preview: false
      })
   });

   useEffect(() => {
      let removeHandle = PubSub.on('logout', (args) => {
         logout()
         navigate('/', {
            replace: true
         });
      });
      return () => removeHandle();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return children
}
